/*
 * Routes-categories.ts
 * Description: Includes the declaration of the
 * categories routes for Vue Router
 */

// Importing components
import PageCategories from '@/pages/categories/PageCategories.vue';
import PageCategoriesUpdate from '@/pages/categories/PageCategoriesUpdate.vue';
import PageCategoriesCreate from '@/pages/categories/PageCategoriesCreate.vue';

const routesCategories = [
    // Defining the categories page route
    {
        path: '/restaurants/:id/categories',
        name: 'categories',
        component: PageCategories,
        props: { id: Number },
        meta: { requiresAuth: true, CreateProducts: true },
    },
    // Defining the categories create page route
    {
        path: '/restaurants/:id/categories/create',
        name: 'categories-create',
        component: PageCategoriesCreate,
        props: { id: Number },
        meta: { requiresAuth: true, CreateProducts: true },
    },
    // Defining the categories update page route
    {
        path: '/restaurants/:id/categories/:category_id/update',
        name: 'categories-update',
        component: PageCategoriesUpdate,
        props: { id: Number, category_id: Number },
        meta: { requiresAuth: true, EditProducts: true },
    },
];
export default routesCategories;
